import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = ({ className, color }) => {
  const svgClassName = ['icon__external-link'];

  if (className) {
    svgClassName.push(className);
  }

  return (
    <svg viewBox="0 0 10 10" className={svgClassName.join(' ')}>
      <path
        d="M9.85.147c.092.09.15.214.15.35V5H9V1.707L3.854 6.854l-.708-.708L8.293 1H5V0h4.502c.14 0 .265.056.354.146H9.85zM0 .51C0 .228.232 0 .5 0H1v10H.5c-.276 0-.5-.228-.5-.51V.51zM1 9h8v1H1V9zm8-2h1v2.505c0 .273-.232.495-.5.495H9V7zM1 0h2v1H1V0z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

ExternalLink.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

ExternalLink.defaultProps = {
  color: '#409FFF',
};

export default ExternalLink;
